<template>
  <span v-if="production">
    <v-row justify="center">
      <v-col md="2" cols="4">
        <img src="/img/icon.svg" alt="Logo do ElectroSFI" width="100%" />
      </v-col>
    </v-row>
    <h1 class="text-h5 text-sm-h4 text-md-h3 text-center headerText">
      <strong>{{ is3d ? simulation.title : production.title }} </strong>
    </h1>
    <v-row justify="center" class="ma-2">
      <v-chip class="ma-2" color="" v-if="create_date">
        Created: {{ formatDate(new Date(create_date)) }}
      </v-chip>
      <v-chip class="ma-2" color="">
        {{
          production.GeometryList.length > 0
            ? production.GeometryList.length
            : 0
        }}
        Geometries
      </v-chip>
      <v-chip class="ma-2">
        {{ production.SourcesList.length }} Sources
      </v-chip>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <p class="text-caption mb-0">Description:</p>
        <p class="mt-0 text-body">
          {{ is3d ? simulation.description : production.description }}
        </p>
      </v-col>
      <v-col cols="12" md="6" v-if="!is3d">
        <p class="text-caption mb-0">Properties:</p>
        <div>
          <v-chip small class="ma-1">Cell {{ production.coordinates.x }} × {{ production.coordinates.y }} µm</v-chip>
          <v-chip small class="ma-1">Resolution {{ production.resolution }} px/µm</v-chip>
          <v-chip v-if="production.pml" small class="ma-1">PML {{ production.pml.thickness }} µm</v-chip>
          <v-chip v-if="production.boundary && production.boundary !== 'pml'" small class="ma-1">
            {{ production.boundary === "pml_x_periodic_y" ? "Periodic in y" : "Periodic in x" }}
          </v-chip>
          <v-chip v-if="production.until" small class="ma-1">Time {{ production.until }} µm/c</v-chip>
        </div>
      </v-col>
    </v-row>
  </span>
</template>
<script>
import formatDate from "@/common/formatDate";

export default {
  name: "DetailsProductHeader",
  props: {
    production: { type: Object, default: null },
    simulation: { type: Object, default: null },
    create_date: { type: String, default: null },
    is3d: { type: Boolean, default: false }
  },
  methods: {
    formatDate
  }
};
</script>
<style>
.headerText {
  overflow: hidden;
  max-width: 100vw;
  text-overflow: ellipsis;
}
</style>
